const ImageDropIconSVG = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="50"
      height="35"
      viewBox="0 0 50 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="15.1369"
        y="0.427461"
        width="34.3087"
        height="27.272"
        rx="4.2"
        fill="white"
        stroke="#E0E0E0"
        strokeWidth="0.56"
        strokeLinecap="round"
        strokeDasharray="2.8 2.8"
      />
      <path
        d="M39.0479 12.0679L35.1289 26.6938L35.0054 26.8336C34.9353 26.7214 34.862 26.6124 34.7958 26.4978C32.7774 23.0051 30.7655 19.5092 28.7402 16.0205C27.8175 14.4313 26.0905 13.9727 24.497 14.8777C23.5163 15.4348 22.5418 16.0027 21.5654 16.5684C19.6488 17.6788 17.7323 18.7918 15.8155 19.9031C15.6381 19.9043 15.6201 19.7431 15.5565 19.6376C15.351 19.2963 15.1562 18.9487 14.9565 18.604C13.9299 16.8315 12.2613 16.3835 10.4888 17.4069C7.44047 19.1655 4.3937 20.9246 1.34482 22.6822C1.2078 22.7613 1.06364 22.827 0.923645 22.8986C0.797631 22.7267 0.912411 22.5639 0.954605 22.4064C2.60077 16.2505 4.24539 10.0942 5.90257 3.94035C6.41286 2.0452 8.03052 0.821534 9.92406 0.967367C10.0352 0.975634 36.6427 8.12248 36.7438 8.14957C38.4482 8.60625 39.609 9.97377 39.0481 12.0671L39.0479 12.0679ZM12.0852 13.7709C13.9062 14.2646 15.7855 13.1913 16.2723 11.3808C16.7485 9.60975 15.6692 7.70646 13.9206 7.23295C12.0587 6.72826 10.1907 7.76821 9.67952 9.59279C9.17733 11.3867 10.2663 13.2785 12.085 13.7716L12.0852 13.7709Z"
        fill="#DADADA"
      />
      <path
        d="M35.0047 26.8344C34.6005 28.3459 34.2019 29.8582 33.7923 31.3683C33.205 33.5357 31.2062 34.7151 29.0353 34.1533C26.9945 33.6247 24.9616 33.0634 22.925 32.516C22.877 32.408 22.8387 32.2944 22.7802 32.1918C21.2107 29.4349 19.6412 26.6781 18.0668 23.924C17.3751 22.7136 16.672 21.5093 15.9766 20.3004C15.9057 20.1763 15.7996 20.0627 15.8161 19.9025C17.7321 18.791 19.6485 17.678 21.5659 16.5678C22.5423 16.0021 23.5161 15.434 24.4976 14.8771C26.0901 13.9727 27.8173 14.4305 28.7408 16.0199C30.7661 19.5086 32.7787 23.0047 34.7964 26.4972C34.8625 26.6118 34.9357 26.7215 35.0059 26.833L35.0047 26.8344Z"
        fill="#BDBDBD"
      />
      <path
        d="M15.8164 19.9024C15.7997 20.0634 15.905 20.1768 15.977 20.3003C16.6723 21.5092 17.3755 22.7135 18.0671 23.9239C19.6415 26.678 21.211 29.4349 22.7805 32.1917C22.8391 32.2943 22.8775 32.4072 22.9253 32.516C22.8091 32.4956 22.6899 32.4835 22.5764 32.4531C16.3252 30.7797 10.0745 29.1074 3.82477 27.4286C1.87846 26.9054 0.688829 25.3275 0.790706 23.4313C0.800398 23.2469 0.807831 23.0586 0.923535 22.8985C1.06431 22.827 1.20867 22.7606 1.34471 22.6821C4.39282 20.9242 7.44057 19.1646 10.4887 17.4067C12.2617 16.3844 13.9296 16.8321 14.9564 18.6039C15.1561 18.9486 15.3509 19.2961 15.5564 19.6375C15.62 19.743 15.639 19.9036 15.8154 19.9029L15.8164 19.9024Z"
        fill="#CACACA"
      />
      <path
        d="M12.0853 13.7708C10.2674 13.2779 9.17766 11.3858 9.67985 9.59194C10.1903 7.76715 12.059 6.7274 13.9209 7.23209C15.6696 7.7056 16.7481 9.60868 16.2726 11.38C15.7857 13.1912 13.9073 14.2639 12.0855 13.77L12.0853 13.7708Z"
        fill="white"
      />
      <path
        d="M38.002 21.45L35.2051 14.6575L41.9976 17.4544L39.4944 18.5272C39.3059 18.6081 39.1557 18.7583 39.0748 18.9468L38.002 21.45Z"
        fill="white"
        stroke="#949494"
        strokeWidth="0.799126"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ImageDropIconSVG;
